// src/pages/IndoorMap/mapData.js

// Matches the InDoorMap.png source resolution (8000x4500) divided by 5,
// so every route SVG can share this exact viewBox with no aspect-ratio drift.
export const MAP_VIEWBOX = "0 0 1600 900"

export const ROOMS = [
  { id: "main-hall", label: "Convention Hall" },
  { id: "food-radio", label: "Courtyard" },
  { id: "experience-zone", label: "Scarlet Ballroom" },
  // { id: "tulip-prefunction", label: "Tulip Pre-Function" },
  { id: "valet", label: "Convention Hall Entrance" },
]

// Pixel position (in MAP_VIEWBOX's 1600x900 coordinate space) of each
// room's clickable marker dot on the floor map. Pulled directly from the
// routeStart/routeEnd circles already authored inside the route SVGs, so
// these line up exactly with where each route's endpoint marker sits.
//
// tulip-prefunction has no route SVG yet (see routeAssets.js), so there's
// no known coordinate for it — fill in its real x/y once you have one.
// Until then, RoomMarkers simply skips drawing a dot for it.
export const ROOM_POINTS = {
  "experience-zone": { x: 1302.2, y: 245.6 },
  "food-radio": { x: 830.4, y: 275.2 },
  "main-hall": { x: 381.4, y: 480 },
  "valet": { x: 375, y: 875 },
  // "tulip-prefunction": { x: 0, y: 0 }, // TODO: fill in real coordinates
}